import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import {
    displayableCashback,
    getMerchantCardUrl,
    renderPluralConditional,
    isMultiDiscount,
    isMultiDiscountOffline,
    hasCashback,
    hasOffline,
    hasCashbackOffline,
    hasOnAndOffCashback,
    hasEbonCashback
} from '../../../services/partner/utils';

import { STATIC_ROOT } from '../../../constants';

import SvgComponent from '../../SvgComponent';
import LocalizedNavLink from '../../router/LocalizedNavLink';

const renderUpTo = (partner, UPTO, isOffline) =>
    partner &&
    ((!isOffline && isMultiDiscount(partner)) || (isOffline && isMultiDiscountOffline(partner)))
        ? UPTO
        : '';

const mapStateToPropsResultCashback = state => ({
    REFUND: state.i18n.feature.partenaire.rembourse,
    UPTO: state.i18n.feature.partenaire.jusqua,
    ONLINE: state.i18n.feature.partenaire.ONLINE,
    OFFLINE: state.i18n.feature.partenaire.OFFLINE,
    EBON_REFUND: state.i18n.feature.partenaire.EBON_REFUND
});
const ResultCashback = connect(mapStateToPropsResultCashback)(({ partner, REFUND, UPTO, ONLINE }) =>
    hasCashback(partner) ? (
        <div className="value">
            <SvgComponent
                src={`${STATIC_ROOT}/picto-en-ligne.svg`}
                width="20"
                height="20"
                aria-hidden="true"
                focusable="false"
            />
            {renderUpTo(partner, UPTO)}&nbsp;
            <span>
                {displayableCashback(
                    partner.mostDisplayableDiscountOnline.percent,
                    partner.mostDisplayableDiscountOnline.fixed
                )}
            </span>
            &nbsp;
            {renderPluralConditional(
                REFUND,
                () =>
                    partner &&
                    (partner.mostDisplayableDiscountOnline.fixed > 1 ||
                        partner.mostDisplayableDiscountOnline.percent > 1)
            )}
            &nbsp;{ONLINE}
        </div>
    ) : null
);
const ResultCashbackOffline = connect(mapStateToPropsResultCashback)(
    ({ partner, REFUND, UPTO, OFFLINE }) =>
        hasOffline(partner) && hasCashbackOffline(partner) ? (
            <div className="value">
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-magasin.svg`}
                    width="20"
                    height="20"
                    aria-hidden="true"
                    focusable="false"
                />
                {renderUpTo(partner, UPTO, true)}&nbsp;
                <span>
                    {displayableCashback(
                        partner.mostDisplayableDiscountOffline.percent,
                        partner.mostDisplayableDiscountOffline.fixed
                    )}
                </span>
                &nbsp;
                {renderPluralConditional(
                    REFUND,
                    () =>
                        partner &&
                        (partner.mostDisplayableDiscountOffline.fixed > 1 ||
                            partner.mostDisplayableDiscountOffline.percent > 1)
                )}
                &nbsp;{OFFLINE}
            </div>
        ) : null
);
const ResultCashbackEbon = connect(mapStateToPropsResultCashback)(
    ({ partner, REFUND, EBON_REFUND }) =>
        hasEbonCashback(partner) ? (
            <div className="value">
                <SvgComponent
                    src={`${STATIC_ROOT}/picto-ebon.svg`}
                    width="21"
                    height="16"
                    aria-hidden="true"
                    focusable="false"
                />
                <span>
                    {displayableCashback(
                        partner.ebonDiscount.cashback.percent.value,
                        partner.ebonDiscount.cashback.fixed.value
                    )}
                </span>
                &nbsp;
                {renderPluralConditional(
                    REFUND,
                    () =>
                        partner &&
                        (partner.ebonDiscount.cashback.percent.value > 1 ||
                            partner.ebonDiscount.cashback.fixed.value > 1)
                )}
                &nbsp;{EBON_REFUND}
            </div>
        ) : null
);

const ResultCodeReduction = ({ partner }) =>
    partner.couponCount > 0 && (
        <React.Fragment>
            <SvgComponent
                src={`${STATIC_ROOT}/code-promo.svg`}
                width="18"
                height="22"
                aria-hidden="true"
                focusable="false"
            />
            {partner.couponCount}
        </React.Fragment>
    );

export const ResultComponent = ({ partner, onClick }) => (
    <li className={`resultat ${hasOnAndOffCashback(partner) ? 'large' : ''}`}>
        {hasEbonCashback(partner) ? (
            <LocalizedNavLink to={getMerchantCardUrl(partner, false, true)} onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        <ResultCashbackEbon partner={partner} />
                    </div>
                </div>
            </LocalizedNavLink>
        ) : (
            <LocalizedNavLink
                to={getMerchantCardUrl(partner, !hasCashback(partner))}
                onClick={onClick}>
                <div className="resultat-conteneur flex-container-h flex-center-alt">
                    <div className="partnerName">{partner.name}</div>
                    <div className="resultat-valeur">
                        <React.Fragment>
                            {hasCashback(partner) && <ResultCashback partner={partner} />}
                            {hasOnAndOffCashback(partner) && (
                                <MediaQuery query="(min-width: 769px)">
                                    {matches => (matches ? <br /> : '')}
                                </MediaQuery>
                            )}
                            {hasOffline(partner) && hasCashbackOffline(partner) && (
                                <ResultCashbackOffline partner={partner} />
                            )}
                        </React.Fragment>
                    </div>
                    <div className="coupon">
                        {partner.couponCount > 0 && <ResultCodeReduction partner={partner} />}
                    </div>
                </div>
            </LocalizedNavLink>
        )}
    </li>
);



// WEBPACK FOOTER //
// ./src/components/header/search/ResultComponent.js